import ReportController from './report.controller';

export default class SnapshotReportController
{
	constructor($http, $scope, AppService, DateRangeService) {
		// Dependancies
		this.$http = $http;
		this.$scope = $scope;

		this.$scope.$parent.title = this.title;
		this.$scope.$parent.endpoint = this.endpoint;

		this.AppService = AppService;
		this.DateRangeService = DateRangeService;

		this.baseData = null;
		this.compareData = null;
		this.combinedData = {
			countries: null,
			referrals: null,
			states: null
		};

		// Register events
		this.$scope.$on('base-range-update', () => { this.updateBaseData() });
		this.$scope.$on('compare-range-update', () => { this.updateCompareData() });

		this.updateData();
	}

	get title() {
		return 'Snapshot Report';
	}

	get endpoint() {
		return 'snapshot';
	}

	setPeriod(period)
	{
		this.AppService.period = period;
		this.updateData();
	}

	updateData() {
		this.updateBaseData();
	}

	updateBaseData() {
		this.AppService.loader = true;
		this.getDataFromApi(
			this.endpoint,
			this.DateRangeService.startDate.format('YYYY-MM-DD'),
			this.DateRangeService.endDate.format('YYYY-MM-DD'),
			(body) => {
				this.baseData = body.data;
				this.combinedData.countries = this.baseData.countries;
				this.combinedData.referrals = this.baseData.referrals;
				this.combinedData.states = this.baseData.states;
				this.updateCompareData()
				this.AppService.loader = false;
			}
		);
	}

	updateCompareData() {
		this.AppService.loader = true;
		this.getDataFromApi(
			this.endpoint,
			this.DateRangeService.compareStartDate.format('YYYY-MM-DD'),
			this.DateRangeService.compareEndDate.format('YYYY-MM-DD'),
			(body) => {
				body.data.countries = this.sortCompareData(this.baseData.countries, body.data.countries);
				body.data.referrals = this.sortCompareData(this.baseData.referrals, body.data.referrals);
				body.data.states = this.sortCompareData(this.baseData.states, body.data.states);
				this.compareData = body.data;
				this.combinedData.countries = this.buildCombinedData(this.baseData.countries, this.compareData.countries);
				this.combinedData.referrals = this.buildCombinedData(this.baseData.referrals, this.compareData.referrals);
				this.combinedData.states = this.buildCombinedData(this.baseData.states, this.compareData.states);
				this.AppService.loader = false;
			}
		);
	}

	buildCombinedData(baseData, compareData) {
		return baseData.map((v, i) => {
			return v.concat(compareData[i][1]);
		});
	}

	sortCompareData(baseData, comparedData) {
		// Sorting algorithm
		let xList = comparedData.map((value, index) => {
			return value[0];
		});

		let sortedData = [];

		for (let i = 0; i < baseData.length; i++) {
			let index = xList.indexOf(baseData[i][0]);
			if (index > -1) {
				sortedData.push(comparedData[index]);
			} else {
				sortedData.push([baseData[i][0], 0]);
			}
		}
		return sortedData;
	}

	getDataFromApi(endpoint, startDate, endDate, callback) {
		this.$http({
			method: 'GET',
			url: '/api/'+endpoint,
			params: {
				start_date: startDate,
				end_date: endDate,
				period: this.AppService.period
			},
			headers: {
				'Content-Type': 'application/json'
			}
		}).then(
			(response) => {
				callback(response.data);
			},
			(response) => {
				alert('Unable to get report data');
				console.log(response);
			}
		);
	}

	getDifference(volume, compareVolume) {
		return (volume - compareVolume) || 0;
	}

	getDifferencePercent(volume, compareVolume) {
		return +(this.getDifference(volume, compareVolume) / volume * 100).toFixed(2) || 0;
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/snapshot.report.controller.js
 **/